import APIHelpCenter from "@/api/modules/help-center";

const state = () => ({
  questionsList: {
    questions: [],
    metadata: {}
  },
  headersData: {},
  question: {}
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    }
  },
  actions: {
    getQuestionsList({ commit }, params) {
      return APIHelpCenter.getQuestionsList(params).then(response => {
        commit("SET_DATA", { type: "headersData", data: response.headers });
        commit("SET_DATA", { type: "questionsList", data: response.data });
      });
    },
    getQuestion({ commit }, questionId) {
      return APIHelpCenter.getQuestion(questionId).then(response => {
        if (response && response.data) {
          commit("SET_DATA", {
            type: "question",
            data: response.data.question
          });
          commit("SET_DATA", {
            type: "question",
            data: response.data.question
          });
        }
      });
    },
    createQuestion(_, payload) {
      return APIHelpCenter.createQuestion(payload);
    },

    deleteQuestion(_, id) {
      APIHelpCenter.deleteQuestion(id);
    },

    addImage(_, { id, file }) {
      return APIHelpCenter.addImage(id, file);
    }
  }
};
